import create from 'zustand/vanilla';
import { persist, createJSONStorage } from "zustand/middleware";

interface SpaceUserState {
    user_id: string
    spacehome_create_step: number;
    nickname?: string;
    path: string;
    design_type?: "custom" | 'banner' | 'text' | '';
    bg_color?: "#ffffff" | '#fff0f5' | '#ffefd5' | '#e7dcef' | "#f5f5dc" | "#e8f5ff"
    custom_bg_color?: "#333333" | '#ffffff' | ''
    user_img_url: string;
    description: string;
    mobile_banner_img_url?: string;
    mobile_bg_img_url?: string;
    user_badge_list: BadgeType[];
    block_list: (BlockLineType | BlockTextType | BlockLinkType | BlockImageType | BlockVideoType | BlockScheduleType | BlockShoppingType)[];
}

interface SpaceUserStatePatch {
    user_id?: string
    spacehome_create_step?: number;
    nickname?: string;
    path?: string;
    design_type?: "custom" | 'banner' | 'text' | '';
    bg_color?: "#ffffff" | '#fff0f5' | '#ffefd5' | '#e7dcef' | "#f5f5dc" | "#e8f5ff"
    custom_bg_color?: "#333333" | '#ffffff' | ''
    user_img_url?: string;
    description?: string;
    mobile_banner_img_url?: string;
    mobile_bg_img_url?: string;
    user_badge_list?: BadgeType[];
    block_list?: (BlockLineType | BlockTextType | BlockLinkType | BlockImageType | BlockVideoType | BlockScheduleType | BlockShoppingType)[];
}
export type BlockListType = (BlockLineType | BlockTextType | BlockLinkType | BlockImageType | BlockVideoType | BlockScheduleType | BlockShoppingType);

export type BlockFormType = 'text' | 'link' | 'schedule' | 'line' | 'image' | 'video' | 'shopping' | 'external-service'
interface BlockDefaultType {
    block_id: string;
    on_off: boolean
    block_order_id: number;
}
export interface BlockLineType extends BlockDefaultType {
    type: 'line'
    line_type: 'line' | 'dash' | 'zigzag' | 'dot' | 'space'
}
export interface BlockTextType extends BlockDefaultType {
    type: 'text'
    description: string;
}
export interface BlockLinkType extends BlockDefaultType {
    type: 'link'
    finish_date: string;
    icon_url: string;
    is_manual: boolean;
    link_label: string;
    link_url: string;
    link_value: string;
    start_date: string;
    finish_time: string;
    start_time: string;
    is_date: boolean;
    title: string;
    badge_list: BadgeType[];
    remain_date: {
        days: number;
        hours: number;
        minutes: number
    }
}
export interface BlockImageType extends BlockDefaultType {
    type: 'image'
    finish_date: string;
    is_date: boolean;
    img_url: string;
    img_link_url: string;
    start_date: string;
    finish_time: string;
    start_time: string;
    title: string;
    badge_list: BadgeType[];
    remain_date: {
        days: number;
        hours: number;
        minutes: number
    }
}
export interface BlockVideoType extends BlockDefaultType {
    type: 'video'
    channel_name: string;
    img_url: string;
    publish_date: string;
    title: string;
    video_url: string;
    embed_url: string;
}
export interface BlockScheduleType extends BlockDefaultType {
    type: 'schedule'
    schedule_list: BlockScheduleItemType[]
}
export interface BlockScheduleItemType {
    schedule_id: string;
    link_url: string;
    finish_date: string;
    start_date: string;
    finish_time: string;
    start_time: string;
    title: string;
    on_off: boolean;
}
export interface BlockShoppingType extends BlockDefaultType {
    type: 'shopping'
    finish_date: string;
    img_url: string;
    link_url: string;
    start_date: string;
    finish_time: string;
    start_time: string;
    title: string;
    badge_list: BadgeType[];
    badge_on_off: boolean;
    remain_date: {
        auto_create_badge: BadgeType
        days: number;
        hours: number;
        minutes: number
    };
    is_date: boolean;
    is_matching: boolean;
    matching_start_date: string;
    matching_start_time: string;
    matching_finish_date: string;
    matching_finish_time: string;
}
export interface BadgeType {
    badge_id: string;
    type: 'solid' | 'outline';
    text: string;
    text_color: string;
    shape: 'oval' | 'rectangle';
    bg_color: string;
    border_color: string;
}

export interface SpaceUserStore extends SpaceUserState {
    setSpaceUserInfo: (user: SpaceUserState) => void;
    patchSpaceUserInfo: (user: SpaceUserStatePatch) => void;
    clearUser: () => void;
}

const initializeState: SpaceUserState = {
    user_id: "",
    spacehome_create_step: 1,
    nickname: "",
    path: "",
    design_type: "",
    bg_color: "#ffffff",
    custom_bg_color: "",
    user_img_url: "",
    description: "",
    mobile_banner_img_url: "",
    mobile_bg_img_url: "",
    block_list: [],
    user_badge_list: [],
}

export const spaceUserStore = create<SpaceUserStore>()(persist((set) => ({
    ...initializeState,

    setSpaceUserInfo: (user: SpaceUserState) => {
        set((state) => (user))
    },

    patchSpaceUserInfo: (user: SpaceUserStatePatch) => {
        console.log(user)
        set((state) => ({
            user_id: user?.user_id || state.user_id,
            spacehome_create_step: user?.spacehome_create_step || state.spacehome_create_step,
            nickname: user?.nickname || state.nickname,
            path: user?.path || state.path,
            design_type: user?.design_type || state.design_type,
            bg_color: user?.bg_color || state.bg_color,
            custom_bg_color: user?.custom_bg_color || state.custom_bg_color,
            user_img_url: user?.user_img_url || state.user_img_url,
            description: user?.description || state.description,
            mobile_banner_img_url: user?.mobile_banner_img_url || state.mobile_banner_img_url,
            mobile_bg_img_url: user?.mobile_bg_img_url || state.mobile_bg_img_url,
            block_list: user?.block_list || state.block_list,
            user_badge_list: user?.user_badge_list || state.user_badge_list
        }))
    },

    clearUser: () => {
        set(initializeState);
    }
}), {
    name: 'space-user-storage',
    storage: createJSONStorage(() => sessionStorage),
}));

const { getState, setState, subscribe, destroy } = spaceUserStore;

export default spaceUserStore;